export var handleize = function (input) {
    return input.replace(/[!@#\$%\^&*()]+/g, '').replace(/\s/g, '-');
};
export var sleep = function (ms) {
    return new Promise(function (resolve) { return setTimeout(resolve, ms); });
};
// Null-safe way to check if a string/array has length
export var notNullAndLengthy = function (predicate) {
    var _a;
    return ((_a = predicate === null || predicate === void 0 ? void 0 : predicate.length) !== null && _a !== void 0 ? _a : 0) > 0;
};
